import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  query($order: [DealersFindOrder!],$where: DealersFindFilter) {\n    exportDealersList(\n      order: $order,\n      where: $where\n    ) {\n      fileName\n      contentB64\n    }\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerId: Int!) {\n    deleteDealer(\n      dealerId: $dealerId\n    )\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerId: Int!, $status: AuditStatus!, $denyReason: String) {\n    auditDealer(\n      dealerId: $dealerId,\n      status: $status,\n      denyReason: $denyReason\n    )\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  query($order: [DealersFindOrder!], $paging: PagingQuery, $where: DealersFindFilter) {\n    findDealers(\n      order: $order,\n      paging: $paging,\n      where: $where,\n    ) {\n      dealers {\n        address\n        denyReason\n        openId\n        areas {\n          cityCode\n          createdAt\n          id\n          ing\n          lat\n          levelType\n          managers {\n            createdBy {\n              id\n              username\n            }\n            modifiedBy {\n              id\n              username\n            }\n          }\n          mergerName\n          name\n          parentId\n          pinyin\n          shortName\n          updatedAt\n          zipCode\n        }\n        covers\n        auditDate\n        applyDate\n        createdAt\n        id\n        ifStoreOpening\n        level\n        managers {\n          createdBy {\n            id\n            username\n          }\n          modifiedBy {\n            id\n            username\n          }\n        }\n        parentId\n        profilePhoto\n        realname\n        schools {\n          id\n          name\n          area {\n            mergerName\n          }\n        }\n        status\n        storeName\n        storePhone\n        updatedAt\n        user {\n          id\n          role\n          username\n          phone\n          email\n        }\n        userId\n      }\n      paging {\n        currentOffset\n        take\n        totalCount\n      }\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  query($dealerId: Int!) {\n    findDealer(\n      dealerId: $dealerId,\n    ) {\n      address\n      denyReason\n      openId\n      areas {\n        cityCode\n        createdAt\n        id\n        ing\n        lat\n        levelType\n        managers {\n          createdBy {\n            id\n            username\n          }\n          modifiedBy {\n            id\n            username\n          }\n        }\n        mergerName\n        name\n        parentId\n        pinyin\n        shortName\n        updatedAt\n        zipCode\n      }\n      covers\n      auditDate\n      applyDate\n      createdAt\n      goodRelations {\n        details\n        price\n        goodId\n        sharingProportion\n        good {\n          id\n          title\n          isbn\n          author\n          status\n          press\n          thumb\n          price\n          details\n        }\n      }\n      sharingProportion\n      id\n      ifStoreOpening\n      level\n      managers {\n        createdBy {\n          id\n          username\n        }\n        modifiedBy {\n          id\n          username\n        }\n      }\n      parentId\n      profilePhoto\n      realname\n      schools {\n        id\n        name\n        area {\n          mergerName\n        }\n      }\n      status\n      storeName\n      storePhone\n      updatedAt\n      user {\n        id\n        role\n        username\n        phone\n        email\n      }\n      userId\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query($areaId: Int!) {\n    findDealersByAreaId(\n      areaId: $areaId,\n    ) {\n      id\n      realname\n      storeName\n      areas {\n        id\n        name\n        mergerName\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var findDealersByAreaId = gql(_templateObject());
export var findDealer = gql(_templateObject2());
export var findDealers = gql(_templateObject3());
export var auditDealer = gql(_templateObject4());
export var deleteDealer = gql(_templateObject5());
export var exportDealersList = gql(_templateObject6());